module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_UpArrow_16"],"polygon":[{"$":{"points":"13 8 8 2 3 8 6 8 6 14 10 14 10 8 13 8","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_UpArrow_16.svg
// module id = tiNg
// module chunks = 1